export const girlsClothingProducts = [
  {
    id: 1,
    name: 'Black Arabic Style Abaya with Gold Embroidery',
    price: 70,
    originalPrice: 70,
    image: 'https://i.imgur.com/XzC8n3L.jpg',
    category: 'Abayas',
    rating: 5,
    reviews: 28,
    description: 'Stunning black abaya featuring intricate heavy gold embroidery in traditional Arabic style. Perfect for special occasions and celebrations.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Black'],
    inStock: true
  },
  {
    id: 2,
    name: 'Maroon Abaya with Floral Embroidery',
    price: 42,
    originalPrice: 42,
    image: 'https://i.imgur.com/sMzYaDI.jpg',
    category: 'Abayas',
    rating: 4.8,
    reviews: 35,
    description: 'Beautiful burgundy maroon abaya adorned with matching floral machine embroidery. Elegant and comfortable for everyday wear.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Maroon'],
    inStock: true
  },
  {
    id: 3,
    name: 'Navy Blue Abaya with Matching Scarf',
    price: 55,
    originalPrice: 55,
    image: 'https://i.imgur.com/hfCa9a3.jpg',
    category: 'Abayas',
    rating: 4.9,
    reviews: 42,
    description: 'Sophisticated navy blue abaya with elegant white trim details. Comes with a coordinating hijab scarf for a complete modest look.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Navy Blue'],
    inStock: true
  },
  {
    id: 4,
    name: 'Blue & Black Abaya with Bead Embroidery',
    price: 65,
    originalPrice: 65,
    image: 'https://i.imgur.com/mJJHSl8.jpg',
    gallery: [
      'https://i.imgur.com/mJJHSl8.jpg',
      'https://i.imgur.com/AYRkj8V.jpg',
      'https://i.imgur.com/Y7inZlj.jpg',
      'https://i.imgur.com/Kxc51mw.jpg',
      'https://i.imgur.com/7l1EDqK.jpg',
      'https://i.imgur.com/HTNi9wJ.jpg',
      'https://i.imgur.com/Kn4O9Xl.jpg'
    ],
    category: 'Abayas',
    rating: 5,
    reviews: 18,
    description: 'Exquisite blue and black abaya featuring stunning bead embroidery on the backside. Comes with a matching blue scarf. Size 56 inches. Perfect blend of elegance and craftsmanship.',
    sizes: ['56 inch'],
    colors: ['Blue & Black'],
    inStock: true
  },
  {
    id: 17,
    name: 'Brown Embroidered Abaya',
    price: 54,
    originalPrice: 54,
    image: 'https://i.imgur.com/wc955BM.jpg',
    gallery: [
      'https://i.imgur.com/wc955BM.jpg',
      'https://i.imgur.com/UtIkPSp.jpg',
      'https://i.imgur.com/jta3pAl.jpg'
    ],
    category: 'Abayas',
    rating: 4.9,
    reviews: 22,
    description: 'Elegant brown abaya with beautiful embroidery details. Size 56 inches. Perfect for everyday elegance and special occasions.',
    sizes: ['56 inch'],
    colors: ['Brown'],
    inStock: true
  },
  {
    id: 18,
    name: 'Dark Navy Blue Abaya with Embroidered Arms',
    price: 45,
    originalPrice: 45,
    image: 'https://i.imgur.com/cPjqrst.jpg',
    gallery: [
      'https://i.imgur.com/cPjqrst.jpg',
      'https://i.imgur.com/PRKP7Ng.jpg',
      'https://i.imgur.com/CSdVlF0.jpg'
    ],
    category: 'Abayas',
    rating: 4.8,
    reviews: 31,
    description: 'Sophisticated dark navy blue abaya with elegant front design and beautiful embroidery on the backside arms and shoulders. Size 54 inches. Simple yet stunning.',
    sizes: ['54 inch'],
    colors: ['Dark Navy Blue'],
    inStock: true
  },
  {
    id: 19,
    name: 'Black Abaya with Gold Arabic Embroidery',
    price: 58,
    originalPrice: 58,
    image: 'https://i.imgur.com/axEfttk.jpg',
    gallery: [
      'https://i.imgur.com/axEfttk.jpg',
      'https://i.imgur.com/gTctW79.jpg'
    ],
    category: 'Abayas',
    rating: 5,
    reviews: 26,
    description: 'Luxurious black abaya featuring exquisite gold embroidery in traditional Arabic style. Size 56 inches. Perfect for special occasions and celebrations.',
    sizes: ['56 inch'],
    colors: ['Black with Gold'],
    inStock: true
  },
  {
    id: 20,
    name: 'Red Abaya with Gold Embroidery',
    price: 59,
    originalPrice: 59,
    image: 'https://i.imgur.com/6795GAe.jpg',
    gallery: [
      'https://i.imgur.com/6795GAe.jpg',
      'https://i.imgur.com/yYbOYlt.jpg'
    ],
    category: 'Abayas',
    rating: 5,
    reviews: 19,
    description: 'Stunning red abaya adorned with elegant gold embroidery. Size 56 inches. Makes a bold and beautiful statement for any special occasion.',
    sizes: ['56 inch'],
    colors: ['Red with Gold'],
    inStock: true
  },
  {
    id: 5,
    name: "Floral Print Modest Dress",
    price: 45.99,
    originalPrice: 59.99,
    image: "https://public.readdy.ai/ai/img_res/04d6f86849774bcba723d57e39ba7c1f.jpg",
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Pink Floral", "Purple Floral", "Blue Floral"],
    description: "Beautiful floral print modest dress perfect for special occasions and everyday wear. Made from soft, breathable fabric. Available in sizes for girls, teens, and women.",
    inStock: true
  },
  {
    id: 6,
    name: "Rainbow Butterfly Abaya",
    price: 52.99,
    originalPrice: 69.99,
    image: "https://readdy.ai/api/search-image?query=colorful%20butterfly%20design%20abaya%20for%20Muslim%20females%20of%20all%20ages%2C%20playful%20Islamic%20modest%20clothing%20suitable%20for%20girls%20teens%20and%20women%2C%20vibrant%20colors%20with%20butterfly%20patterns%2C%20comfortable%20and%20fun%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=girls-abaya1&orientation=portrait",
    category: "Abayas",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Rainbow", "Pink", "Purple"],
    description: "Fun and colorful abaya featuring beautiful butterfly designs. Perfect for those who love vibrant colors. Available in all sizes.",
    inStock: true
  },
  {
    id: 7,
    name: "Pastel Princess Dress",
    price: 48.99,
    originalPrice: 64.99,
    image: "https://readdy.ai/api/search-image?query=elegant%20pastel%20colored%20modest%20dress%20for%20Muslim%20females%2C%20princess%20style%20Islamic%20clothing%20suitable%20for%20all%20ages%2C%20soft%20pink%20and%20lavender%20colors%2C%20beautiful%20and%20comfortable%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=girls-dress2&orientation=portrait",
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Soft Pink", "Lavender", "Mint Green"],
    description: "Elegant pastel dress that makes everyone feel special. Comfortable for all-day wear. Perfect for any occasion.",
    inStock: true
  },
  {
    id: 8,
    name: "Sparkle Star Abaya",
    price: 55.99,
    originalPrice: 72.99,
    image: "https://readdy.ai/api/search-image?query=modest%20abaya%20with%20star%20patterns%20for%20Muslim%20females%2C%20sparkly%20Islamic%20clothing%20suitable%20for%20girls%20teens%20and%20women%2C%20navy%20blue%20with%20silver%20stars%2C%20elegant%20and%20sophisticated%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=girls-abaya2&orientation=portrait",
    category: "Abayas",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Navy Stars", "Purple Stars", "Black Stars"],
    description: "Beautiful abaya with sparkly star patterns. Perfect for special occasions and celebrations. Available in all sizes.",
    inStock: true
  },
  {
    id: 9,
    name: "Garden Party Maxi Dress",
    price: 42.99,
    originalPrice: 56.99,
    image: "https://readdy.ai/api/search-image?query=flowy%20maxi%20dress%20with%20garden%20flowers%20for%20Muslim%20females%2C%20modest%20Islamic%20clothing%20suitable%20for%20all%20ages%2C%20beautiful%20floral%20patterns%2C%20comfortable%20and%20elegant%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=girls-dress3&orientation=portrait",
    category: "Dresses",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Rose Garden", "Daisy Field", "Tulip Pink"],
    description: "Flowing maxi dress with beautiful garden-inspired prints. Perfect for parties and special events. Sizes for everyone.",
    inStock: true
  },
  {
    id: 10,
    name: "Everyday Comfort Abaya",
    price: 38.99,
    originalPrice: 49.99,
    image: "https://readdy.ai/api/search-image?query=simple%20comfortable%20abaya%20for%20Muslim%20females%20daily%20wear%2C%20practical%20Islamic%20clothing%20suitable%20for%20all%20ages%2C%20soft%20colors%2C%20easy%20to%20wear%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=500&seq=girls-abaya3&orientation=portrait",
    category: "Abayas",
    sizes: ["XS", "S", "M", "L", "XL", "Kids 4-6Y", "Kids 7-9Y", "Kids 10-12Y"],
    colors: ["Soft Gray", "Light Blue", "Dusty Rose"],
    description: "Comfortable everyday abaya made from soft, breathable fabric. Perfect for daily activities, work, and school.",
    inStock: true
  }
];

export const girlsAccessoriesProducts = [
  {
    id: 11,
    name: "Rainbow Hijab Set (3-Pack)",
    price: 24.99,
    originalPrice: 32.99,
    image: "https://readdy.ai/api/search-image?query=colorful%20hijab%20set%20for%20Muslim%20females%2C%20three%20beautiful%20headscarves%20in%20rainbow%20colors%20suitable%20for%20all%20ages%2C%20soft%20comfortable%20fabric%2C%20Islamic%20accessories%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-hijab1&orientation=squarish",
    category: "Hijabs",
    sizes: ["One Size"],
    colors: ["Rainbow Mix", "Pastel Mix", "Bright Mix"],
    description: "Set of 3 colorful hijabs in soft, comfortable fabric. Perfect for everyday wear and special occasions.",
    inStock: true
  },
  {
    id: 12,
    name: "Butterfly Hijab Pins Set",
    price: 12.99,
    originalPrice: 16.99,
    image: "https://readdy.ai/api/search-image?query=beautiful%20butterfly%20shaped%20hijab%20pins%20for%20Muslim%20females%2C%20colorful%20decorative%20pins%20suitable%20for%20all%20ages%2C%20Islamic%20accessories%2C%20elegant%20and%20stylish%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-pins1&orientation=squarish",
    category: "Pins & Brooches",
    sizes: ["One Size"],
    colors: ["Multi-Color", "Pink Set", "Purple Set"],
    description: "Adorable butterfly-shaped hijab pins that add a beautiful touch. Safe and easy to use for all ages.",
    inStock: true
  },
  {
    id: 13,
    name: "Flower Crown Hijab Band",
    price: 15.99,
    originalPrice: 21.99,
    image: "https://readdy.ai/api/search-image?query=beautiful%20flower%20crown%20hijab%20band%20for%20Muslim%20females%2C%20decorative%20headband%20with%20flowers%20suitable%20for%20all%20ages%2C%20Islamic%20accessories%2C%20elegant%20and%20pretty%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-band1&orientation=squarish",
    category: "Hair Accessories",
    sizes: ["One Size"],
    colors: ["Pink Roses", "White Daisies", "Purple Lavender"],
    description: "Beautiful flower crown band that sits perfectly over hijab. Makes everyone feel special and elegant.",
    inStock: true
  },
  {
    id: 14,
    name: "Sparkle Hijab Magnets",
    price: 10.99,
    originalPrice: 14.99,
    image: "https://readdy.ai/api/search-image?query=sparkly%20magnetic%20hijab%20pins%20for%20Muslim%20females%2C%20glittery%20decorative%20magnets%20suitable%20for%20all%20ages%2C%20safe%20Islamic%20accessories%2C%20colorful%20and%20elegant%20design%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-magnets1&orientation=squarish",
    category: "Pins & Brooches",
    sizes: ["One Size"],
    colors: ["Silver Sparkle", "Gold Glitter", "Rainbow Shine"],
    description: "Safe magnetic hijab pins with sparkly designs. No sharp edges, perfect for everyone.",
    inStock: true
  },
  {
    id: 15,
    name: "Cotton Jersey Hijab",
    price: 14.99,
    originalPrice: 19.99,
    image: "https://readdy.ai/api/search-image?query=soft%20cotton%20jersey%20hijab%20for%20Muslim%20females%2C%20comfortable%20Islamic%20headscarf%20suitable%20for%20all%20ages%2C%20breathable%20fabric%20in%20pastel%20colors%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-hijab2&orientation=squarish",
    category: "Hijabs",
    sizes: ["One Size"],
    colors: ["Baby Pink", "Sky Blue", "Mint Green", "Lavender"],
    description: "Super soft cotton jersey hijab. Breathable and comfortable for all-day wear. Perfect for any occasion.",
    inStock: true
  },
  {
    id: 16,
    name: "Prayer Beads Collection",
    price: 8.99,
    originalPrice: 12.99,
    image: "https://readdy.ai/api/search-image?query=colorful%20prayer%20beads%20tasbih%20for%20Muslim%20females%2C%20beautiful%20Islamic%20accessories%20suitable%20for%20all%20ages%2C%20bright%20colors%20with%20decorative%20beads%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=girls-beads1&orientation=squarish",
    category: "Prayer Items",
    sizes: ["One Size"],
    colors: ["Pink Pearl", "Purple Gem", "Blue Crystal"],
    description: "Beautiful prayer beads for daily spiritual practice. Helps Muslims of all ages in their faith journey.",
    inStock: true
  }
];

export const allProducts = [...girlsClothingProducts, ...girlsAccessoriesProducts];

// Keep old products for backward compatibility
export const abayaProducts = girlsClothingProducts.filter(p => p.category === 'Abayas');
export const hijabProducts = girlsAccessoriesProducts.filter(p => p.category === 'Hijabs');
